import { render, staticRenderFns } from "./DownApp.vue?vue&type=template&id=457c57e9"
import script from "./DownApp.vue?vue&type=script&lang=js"
export * from "./DownApp.vue?vue&type=script&lang=js"
import style0 from "./DownApp.vue?vue&type=style&index=0&id=457c57e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports